var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm11.16 4.76L3.24 4.85a5.71 5.71 0 007.92 7.92zM4.85 3.24l7.91 7.91A5.7 5.7 0 008 2.3a5.7 5.7 0 00-3.15.95z", "fill-rule": "nonzero" } }] }, name: "stop", theme: "outlined" };
export {
  a as default
};
